import { jsx as _jsx } from "react/jsx-runtime";
import ObjectCard from '../../v2/components/generic/ObjectView/ObjectCard';
import { EntityNetworkSchematicTab } from './Schematic';
export { getEntityNetworkQuery } from './queries';
const debug = process.env.REACT_APP_DEBUG && false;
export const EntityNetworkView = (props) => {
    return _jsx(ObjectCard, { ...props, additionalTabs: { Schematic: EntityNetworkSchematicTab } });
};
